var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsLightSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.498 2.996a4.002 4.002 0 01-4.002 4.002A4.002 4.002 0 016.498 11m0-8.004a4.002 4.002 0 004.001 4.002A4.002 4.002 0 006.498 11m0-8.004v-1m0 9.004v1m11.004 3.001A5.002 5.002 0 0012.5 10a5.002 5.002 0 005.002-5.002m0 10.004A5.002 5.002 0 0122.504 10a5.002 5.002 0 01-5.002-5.002m0 10.004v1m0-11.004v-1M10.5 21.004v1m0-8.003v-1m0 .5a4.002 4.002 0 01-4.001 4.001 4.002 4.002 0 014.001 4.002 4.002 4.002 0 014.002-4.002 4.002 4.002 0 01-4.002-4.001z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStarsLightSparkle;